import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { theme } from 'styles';
import { logoSvg, iconCloseSvg } from 'images';

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${theme.sp.l};
  border-bottom: 1px solid ${theme.colors.border};
  padding: ${theme.sp.m} 0;
  height: 60px;
`;

const Logo = styled.img`
  width: 126px;
`;

const CloseButton = styled.button`
  img {
    width: 16px;
  }
`;

const propTypes = {
  onClose: PropTypes.func.isRequired,
};

function Header({ onClose }) {
  return (
    <StyledHeader>
      <Logo src={logoSvg} alt="MarketTap" />
      <CloseButton onClick={onClose}>
        <img src={iconCloseSvg} alt="Close" />
      </CloseButton>
    </StyledHeader>
  );
}

Header.propTypes = propTypes;

export default Header;



// WEBPACK FOOTER //
// ./src/components/shared/NavDrawer/components/Header.jsx